<template>
    <div id="app">
        <!-- MODALS -->
        <Modal ref="modals"></Modal>

        <!-- SIGNING -->
        <Signing
            :type="'sign'"
            :signData="payment.signData"
            ref="pageSigning"
        ></Signing>

        <nav class="navbar g-navbar-primary g-bg-eg-ocean fixed-top">
            <div class="container justify-content-between">
                <a class="g-navbar-brand" tabindex="-1" href="#">
                    <svg
                        class="ico-george-logo g-bg-eg-ocean"
                        aria-hidden="false"
                        focusable="false"
                    >
                        <use
                            href="#ico-george-logo"
                            xlink:href="#ico-george-logo"
                        />
                    </svg>
                    <p class="g-bg-eg-ocean">
                        {{ slsp.appName }}
                    </p>
                </a>
            </div>
        </nav>

        <main>
            <div class="paymentInfo">
                <div class="container">
                    <div class="row">
                        <div class="col-md-8 offset-md-2 col-sm-12 topwrap">
                            <h1 class="g-no-line">
                                {{ $t("overview.titlePrefix") }}
                            </h1>
                            <div class="card-group g-card-group-vertical">
                                <div class="card g-card">
                                    <div class="card-block">
                                        <p>{{ $t("overview.subTitle") }}</p>
                                    </div>
                                </div>
                                <div class="card g-card">
                                    <div class="card-block pb-0 inner">
                                        <div>
                                            <div
                                                class="row form-group g-form-compact"
                                            >
                                                <label
                                                    for="form-spacing-compact2"
                                                    class="col-md-4 col-form-label col-nowrap"
                                                >
                                                    {{
                                                        $t(
                                                            "overview.title"
                                                        )
                                                    }}</label
                                                >
                                                <div class="col-md-8">
                                                    <p>
                                                        {{ trader.title }}
                                                    </p>
                                                </div>
                                            </div>
                                            <div
                                                class="row form-group g-form-compact"
                                            >
                                                <label
                                                    for="form-spacing-compact2"
                                                    class="col-md-4 col-form-label col-nowrap"
                                                >
                                                    {{
                                                        $t(
                                                            "overview.description"
                                                        )
                                                    }}</label
                                                >
                                                <div class="col-md-8">
                                                    <p>
                                                        {{ trader.description }}
                                                    </p>
                                                </div>
                                            </div>
                                            <div
                                                class="row form-group g-form-compact "
                                            >
                                                <label
                                                    for="form-spacing-compact2"
                                                    class="col-md-4 col-form-label col-nowrap"
                                                >
                                                    {{
                                                        $t("overview.url")
                                                    }}</label
                                                >
                                                <div class="col-md-8">
                                                    <p>{{ trader.url }}</p>
                                                </div>
                                            </div>
                                            <div
                                                class="row form-group g-form-compact"
                                            >
                                                <label
                                                    for="text-inside-single-column-form2"
                                                    class=" col-md-4 col-form-label col-nowrap"
                                                >
                                                    {{
                                                        $t(
                                                            "overview.targetAccount"
                                                        )
                                                    }}</label
                                                >
                                                <div class="col-md-8">
                                                    <div class="custom-a11y__wrapper">
                                                        <div class="custom-a11y__label" :aria-label="$helpers.splitStringForScreanReader(getIban)"></div>
                                                        <p aria-hidden="true">
                                                            {{
                                                                $helpers.ibanReadability(
                                                                    getIban
                                                                )
                                                            }}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                class="row form-group g-form-compact"
                                            >
                                                <label
                                                    for="text-inside-single-column-form1"
                                                    class=" col-md-4 col-form-label col-nowrap"
                                                >
                                                    {{
                                                        $t("overview.myAccount")
                                                    }}</label
                                                >
                                                <div class="col-md-8">
                                                    <!-- Multi account -->
                                                    <select
                                                        v-if="
                                                            payment.accounts
                                                                .length > 1
                                                        "
                                                        id="accountDropdown"
                                                    >
                                                        <option></option>
                                                        <option
                                                            v-for="(account,
                                                            index) in payment.accounts"
                                                            :key="index"
                                                            :id="
                                                                account.accountId
                                                            "
                                                            :aria-label="account.accountName"
                                                        >
                                                            {{ account.accountName }}:
                                                                {{
                                                                    $helpers.ibanReadability(
                                                                        account.accountIban
                                                                    )
                                                                }}
                                                        </option>
                                                    </select>

                                                    <!-- Single account -->
                                                    <div
                                                        v-if="
                                                            payment.accounts
                                                                .length === 1
                                                        "
                                                        class="col-12 col-md-8 pl-0 mw-100"
                                                    >
                                                        <p>
                                                            {{
                                                                payment
                                                                    .accounts[0]
                                                                    .accountName
                                                            }}:
                                                            <span
                                                                style="white-space:nowrap"
                                                                >{{
                                                                    $helpers.ibanReadability(
                                                                        payment
                                                                            .accounts[0]
                                                                            .accountIban
                                                                    )
                                                                }}</span
                                                            >
                                                        </p>
                                                    </div>

                                                    <div
                                                        v-if="
                                                            !payment.isValid &&
                                                                payment.error !=
                                                                    ''
                                                        "
                                                        class="card g-card g-card-alert-error mt-2 errbox"
                                                    >
                                                        <div
                                                            class="card-block pt-1 pb-1 pl-2 pr-2"
                                                        >
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                                                width="16"
                                                                height="14"
                                                                viewBox="0 0 16 14"
                                                                focusable="false"
                                                                :title="$t('icon.warning')"
                                                            >
                                                                <defs>
                                                                    <path
                                                                        id="warning_icon_red-a"
                                                                        d="M2.9212,13.6424667 C1.40010378,13.6424667 0.436071831,12.0114921 1.16905695,10.6785192 L6.24713644,1.44570806 C7.00713013,0.0647195357 8.99193654,0.0647195357 9.75200972,1.44585255 L14.8300384,10.6785713 C15.5630052,12.0115111 14.5982746,13.6424667 13.0772,13.6424667 L2.9212,13.6424667 Z M2.9212,12.3091333 L13.0772,12.3091333 C13.5842874,12.3091333 13.9059833,11.7652803 13.6617236,11.3210808 L8.58380311,2.08855861 C8.33046346,1.6282138 7.66860321,1.6282138 7.41534305,2.08841412 L2.33737169,11.3210287 C2.09297973,11.7654687 2.41432756,12.3091333 2.9212,12.3091333 Z M8.666,7.64246667 C8.666,8.0106565 8.36752317,8.30913333 7.99933333,8.30913333 C7.6311435,8.30913333 7.33266667,8.0106565 7.33266667,7.64246667 L7.33266667,4.9758 C7.33266667,4.60761017 7.6311435,4.30913333 7.99933333,4.30913333 C8.36752317,4.30913333 8.666,4.60761017 8.666,4.9758 L8.666,7.64246667 Z M8,10.9738667 C7.632,10.9738667 7.33333333,10.6752 7.33333333,10.3072 C7.33333333,9.93853333 7.632,9.64053333 8,9.64053333 C8.368,9.64053333 8.66666667,9.93853333 8.66666667,10.3072 C8.66666667,10.6752 8.368,10.9738667 8,10.9738667 Z"
                                                                    />
                                                                </defs>
                                                                <use
                                                                    fill="#B33C3C"
                                                                    xlink:href="#warning_icon_red-a"
                                                                />
                                                            </svg>
                                                            <div
                                                                class="g-card-alert-data"
                                                            >
                                                                <p>
                                                                    {{
                                                                        $t(
                                                                            payment.error
                                                                        )
                                                                    }}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                class="row form-group g-form-compact"
                                            >
                                                <label
                                                    for="text-inside-single-column-form1"
                                                    class="col-md-4 col-form-label col-nowrap"
                                                    >{{
                                                        $t("overview.amount")
                                                    }}</label
                                                >
                                                <div class="col-md-8 amount">
                                                    <p
                                                        class="pb-0"
                                                        style="font-weight: bold; font-size: 1.1em;"
                                                    >
                                                        {{
                                                            currencySymbols[
                                                                payment.mena
                                                            ] ||
                                                                currencySymbols.EUR
                                                        }}
                                                        {{ $helpers.formatNumber(payment.suma) }}
                                                    </p>

                                                    <p
                                                        class="g-faded"
                                                        v-if="
                                                            payment.diff !== ''
                                                        "
                                                        style="font-size: 0.85em;"
                                                    >
                                                        {{
                                                            $t(
                                                                "overview.afterPaymentPrefix"
                                                            )
                                                        }}:

                                                        <span
                                                            :class="{
                                                                positive:
                                                                    payment.diff >
                                                                    0
                                                            }"
                                                        >
                                                            {{
                                                                currencySymbols[
                                                                    payment.mena
                                                                ] ||
                                                                    currencySymbols.EUR
                                                            }}
                                                            {{ $helpers.formatNumber(payment.diff) }}
                                                        </span>
                                                    </p>
                                                </div>
                                            </div>
                                            <div
                                                class="row form-group g-form-compact"
                                                v-if="trader.accredited"
                                            >
                                                <label
                                                    for="text-inside-single-column-form2"
                                                    class=" col-md-4 col-form-label col-nowrap"
                                                >
                                                    {{
                                                        $t(
                                                            "overview.variableSymbol"
                                                        )
                                                    }}</label
                                                >
                                                <div class="col-md-8">
                                                    <div class="custom-a11y__wrapper">
                                                        <div class="custom-a11y__label" :aria-label="$helpers.splitStringForScreanReader(trader.vs)"></div>
                                                        <p aria-hidden="true">{{ trader.vs }}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                class="row form-group g-form-compact"
                                                v-if="trader.accredited"
                                            >
                                                <label
                                                    for="text-inside-single-column-form3"
                                                    class="col-md-4 col-form-label col-nowrap"
                                                    >{{
                                                        $t(
                                                            "overview.specificSymbol"
                                                        )
                                                    }}</label
                                                >
                                                <div class="col-md-8">
                                                    <div class="custom-a11y__wrapper">
                                                        <div class="custom-a11y__label" :aria-label="$helpers.splitStringForScreanReader(trader.ss)"></div>
                                                        <p aria-hidden="true">{{ trader.ss }}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                v-if="!trader.accredited"
                                                class="row form-group g-form-compact"
                                            >
                                                <label
                                                    for="text-inside-single-column-form3"
                                                    class="col-12 col-md-4 col-form-label col-nowrap"
                                                    >{{
                                                        $t("overview.bic")
                                                    }}</label
                                                >
                                                <div class=" col-md-8">
                                                    <p>{{ slsp.bic }}</p>
                                                </div>
                                            </div>
                                            <div
                                                v-if="!trader.accredited"
                                                class="row form-group g-form-compact"
                                            >
                                                <label
                                                    for="text-inside-single-column-form3"
                                                    class="col-12 col-md-4 col-form-label col-nowrap"
                                                    >{{
                                                        $t("overview.payeeRef")
                                                    }}</label
                                                >
                                                <div class="col-md-8">
                                                    <p>{{ trader.payeeRef }}</p>
                                                </div>
                                            </div>
                                            <template v-if="!trader.accredited">
                                                <div
                                                    class="row form-group g-form-compact"
                                                    v-for="(msg,
                                                    key) in usedRecipientMessages"
                                                    :key="key"
                                                >
                                                    <label
                                                        for="text-inside-single-column-form3"
                                                        class="col-md-4 col-form-label col-nowrap"
                                                    >
                                                        {{
                                                            $t(
                                                                "overview.recipientMsg"
                                                            ) +
                                                                " " +
                                                                key.slice(-1)
                                                        }}
                                                    </label>
                                                    <div class="col-md-8">
                                                        <p>{{ msg }}</p>
                                                    </div>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                    <br aria-hidden="true" />
                                </div>
                            </div>
                            <div class="g-group g-group-button text-right">
                                <a
                                    role="button"
                                    tabindex="0"
                                    class="focusable btn btn-lg g-bg-g-transparent g-btn-outline-secondary"
                                    @click="leaveAndInvalidate(false)"
                                >
                                    <span>{{
                                        $t("overview.buttonAbort")
                                    }}</span>
                                </a>
                                <button
                                    type="button"
                                    class="btn focusable btn-lg g-btn-primary"
                                    @click="signPayment"
                                    :disabled="!payment.isValid"
                                >
                                    <span>{{ $t("overview.buttonSign") }}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>

        <!-- FOOTER -->
        <Footer></Footer>
    </div>
</template>

<script>
import AuthToken from "./authToken";
import { store } from "./store/store";
import Modal from "./components/Modal.vue";
import Signing from "./components/pages/Signing.vue";
import Footer from "./components/Footer.vue";
import { v4 as uuidv4 } from 'uuid';

export default {
    name: "App",

    components: {
        Modal,
        Signing,
        Footer
    },

    data() {
        return {
            slsp: {
                appName: "Sporopay",
                bic: "GIBASKBX",
                bankCode: "0900"
            },
            trader: {
                url: "",
                title: "",
                description: "",
                puCislo: "",
                puPredcislo: "",
                puKbanky: "",
                vs: "",
                ss: "",
                payeeRef: "",
                accredited: false,
                leaveUrl: ""
            },
            payment: {
                accounts: [],
                selectedAccount: "",
                recipientMessages: {},
                suma: "",
                isValid: false,
                mena: "",
                diff: "",
                error: "",
                signData: {}
            },
            configuration: {
                falseAlias: "stnop",
                trueAlias: "styes",
                delimiters: {
                    inner: "b",
                    outer: "a"
                }
            },
            leaving: false,
            signing: false,
            currencySymbols: {
                USD: "$", // US Dollar.
                EUR: "€", // Euro.
                CRC: "₡", // Costa Rican Colón.
                GBP: "£", // British Pound Sterling.
                ILS: "₪", // Israeli New Sheqel.
                INR: "₹", // Indian Rupee.
                JPY: "¥", // Japanese Yen.
                KRW: "₩", // South Korean Won.
                NGN: "₦", // Nigerian Naira.
                PHP: "₱", // Philippine Peso.
                PLN: "zł", // Polish Zloty.
                PYG: "₲", // Paraguayan Guarani.
                THB: "฿", // Thai Baht.
                UAH: "₴", // Ukrainian Hryvnia.
                VND: "₫" // Vietnamese Dong.
            }
        };
    },

    computed: {
        usedRecipientMessages() {
            const messages = this.payment.recipientMessages;
            const keys = Object.keys(messages);

            for (let i = 0; i < keys.length; i++) {
                if (messages[keys[i]] === "") {
                    delete messages[keys[i]];
                }
            }

            return messages;
        },

        getIban() {
            if (!this.trader.creditAccountIban && !this.trader.puCislo) return '';

            return this.trader.creditAccountIban || this.$helpers.generateIban("SK", this.trader.puPredcislo, this.trader.puCislo, this.trader.puKbanky);
        }
    },

    methods: {
        /**
         * Add protocol if missing (force https).
         *
         * @param url - Return url precursor
         * @returns Polished url
         */
        addUrlComponentsIfMissing(url) {
            // Add protocol to url if missing.
            if (!url.match(/:\/\//i)) {
                url = "https://" + url;
            }

            let params = url.split("?");

            // Check if url has parameters.
            if (params.length > 1 && params[1] != "") {
                url += "&";

                // If not, check if it has questionmark trailing.
            } else {
                // If not, add questionmark.
                if (!url.match(/\?$/)) {
                    url += "?";
                }
            }

            return url;
        },

        /**
         * Generic loggin function.
         *
         * @param action - Action name
         * @param data - Data to log
         * @param sidInject - Used when sid is no longer present in cookies but it's value is needed to create logs.
         */
        genericLogger(action, data, sidInject) {
            this.$api
                .log({
                    sid: store.getters.getOne("sid") || sidInject || "",
                    action,
                    account_client:
                        this.payment?.selectedAccount?.accountNumber ||
                        (this.payment?.accounts?.[0] &&
                            this.payment?.accounts?.[0]?.accountNumber) ||
                        null,
                    account_merchant: this.trader.puCislo || null,
                    data
                })
                .catch(e => {
                    console.log(e);
                });
        },

        /**
         * Disable screen clicking and blur it.
         */
        disableScreen() {
            document.body.style.opacity = 0.7;
            document.body.style.pointerEvents = "none";
        },

        /**
         * Show signing screen.
         */
        signPayment() {
            this.genericLogger("sign button clicked", "");
            if (this.signing) {
                return false;
            }

            const vue = this;
            const storeParams = store.getters.getStoreParams;
            this.signing = true;

            this.disableScreen();

            vue.$refs.pageSigning.engageSigning({
                // getSignId request data.
                getId: {
                    accountPrefix: vue.payment.selectedAccount.accountPrefix,
                    accountNumber: vue.payment.selectedAccount.accountNumber,
                    accountBankCode: vue.slsp.bankCode,
                    pu_predcislo: storeParams.puPredcislo,
                    pu_cislo: storeParams.puCislo,
                    pu_kbanky: storeParams.puKbanky,
                    creditAccountIban: storeParams.creditAccountIban,
                    creditAccountName: storeParams.creditAccountName,
                    creditAccountBic: storeParams.creditAccountBic,
                    suma: storeParams.suma,
                    mena: storeParams.mena,
                    endToEndId: storeParams.endToEndId,
                    recipientMessage1: storeParams.recipientMessage1,
                    recipientMessage2: storeParams.recipientMessage2,
                    recipientMessage3: storeParams.recipientMessage3,
                    recipientMessage4: storeParams.recipientMessage4,
                    ss: storeParams.ss,
                    vs: storeParams.vs,
                    language: storeParams.language,
                    emailNotification: "1",
                    emailAddress: storeParams.emailAddress,
                    url: storeParams.url,
                    param: storeParams.param,
                    sign1: storeParams.sign1
                }
            });
        },

        /**
         * Kill program execution by throwing error.
         *
         * @param message - Error message
         * @param fatal - If should terminate the flow
         * @param translateNode - Modal text can be dynamically translated
         */
        die(message, fatal, translateNode) {
            let errorId = store.getters.getOne("errorId");

            if (!errorId) {
              errorId = uuidv4();
              store.dispatch("setOne", {
                key: "errorId",
                value: errorId,
              });
            }

            this.$refs.modals.hide("sign");
            this.$refs.modals.hide("process");
            this.$refs.modals.show(
                "failed",
                fatal,
                translateNode ? { ...translateNode, errorId } : { translate: "generic", errorId }
            );
            clearInterval(store.getters.getOne("mTokenRefresh"));
            clearInterval(store.getters.getOne("refreshToken"));

            const params = this.$helpers.paramsToObject();
            const sid = store.getters.getOne('sid') || params.state?.split("||")[2] || 'no-sid';

            this.genericLogger("error-die", { message, errorId }, sid);
            // this.$api.invalidateToken();
            this.clearSidAndDataId();
            throw new Error(JSON.stringify({ message, errorId }));
        },

        /**
         * Erase hash from url.
         */
        rmHash() {
            history.pushState("", document.title, window.location.pathname);
        },

        /**
         * Start general timer that disconnects user after period of time.
         *
         * @param after - Milliseconds the session lasts
         */
        engageGeneralTimeout(after) {
            setTimeout(() => {
                this.die("Session expired.", true, {
                    translate: true,
                    title: "modals.timeout.title",
                    caption: "modals.timeout.caption"
                });
            }, after);
        },

        /**
         * Redirect user back to merchant and invalidate auth token.
         *
         * @param success - Flag if payment was successful
         */
        async leaveAndInvalidate(success) {
            // Will be decided later.
            let leaveUrl;

            // Prevent double click on leave action.
            if (this.leaving) {
                return false;
            }
            this.leaving = true;

            // Decide leave url.
            if (success) {
                leaveUrl = this.trader.leaveUrl;
            } else {
                let paramPrefix =
                    store.getters.getOne("param") !== ""
                        ? store.getters.getOne("param") +
                          "&param=" +
                          encodeURIComponent(store.getters.getOne("param")) +
                          "&"
                        : "";
                leaveUrl =
                    this.addUrlComponentsIfMissing(
                        store.getters.getOne("url")
                    ) +
                    paramPrefix +
                    "result=nok&real=nok";
            }

            // Add empty param if missing.
            if (!leaveUrl.includes("&param=")) {
                leaveUrl += "&param=";
            }

            // Log data.
            await this.genericLogger("merchant_return_url", { url: leaveUrl });

            // Before redirecting wait for token invalidation.
            await this.$api.invalidateToken();

            // Finally leave.
            location.href = leaveUrl;
        },

        /**
         * Find selected account by IBAN.
         *
         * @param iban - IBAN string
         */
        setSelectedAccount(iban) {
            this.payment.accounts.some(account => {
                if (account.accountIban === iban) {
                    this.payment.selectedAccount = account;
                    return true;
                }
            });
        },

        /**
         * Formats select2 list.
         *
         * @param item - Content to be wrapped in spans
         */
        formatDesign(item) {
            return $(`<span>${item.text}</span>`)[0];
        },

        /**
         * Create Select2 component.
         */
        handleSelect2() {
            const vue = this;

            $("#accountDropdown").select2({
                width: "100%",
                tabIndex: "1",
                placeholder: this.$t("overview.dropdownDefault"),
                templateResult: this.formatDesign,
                templateSelection: this.formatDesign
            });

            $("#accountDropdown").on("select2:select", e => {
                if (e.params.data.id === vue.$t("overview.dropdownDefault")) {
                    vue.payment.selectedAccount = "";
                    vue.payment.diff = "";
                    vue.payment.isValid = false;
                    vue.payment.error =
                        "overview.errors.noAccountSelectedError";
                    vue.payment.signData = {};
                    return false;
                }

                let accountIban = this.$helpers.getAccountIbanFromRequestResult(
                    e.params.data.id
                );
                let accountName = this.$helpers.getAccountNameFromRequestResult(
                    e.params.data.id
                );

                vue.accountSelectionRoutine({ accountIban, accountName });
            });

            // @problem{Select2 ARIA}
            $(".select2-selection").attr("role", "textbox");
            $(".select2-selection").removeAttr("aria-expanded");
        },

        /**
         * Obtain SecV url.
         */
        async obtainSecvUrl() {
            // Perform login API call.
            try {
                const response = await this.$api.login();
                let url = response.data.loginUrl;

                // If url is valid, return it.
                if (url) {
                    return url;

                    // Otherwise throw error.
                } else {
                    throw new Error("Nonexistent url.");
                }

                // Call failed.
            } catch (e) {
                this.die("Could not retrieve SecV url.", e, true);
            }
        },

        /**
         * Validate CSRF token.
         *
         * @param params - Program URL parameters
         */
        async validateSession(params) {
            // State is ok.
            if (params.state && params.state?.split("||").length === 3) {
                const sid = params.state?.split("||")[2];

                this.genericLogger("state_ok", { state: params.state }, sid);

                const cookie_token = this.$cookies.get("_csrf");
                const state_token =
                    params.state?.split("||")[1] || "invoke_failure";

                // CSRF token is bad.
                if (cookie_token !== state_token) {
                    this.die(`CSRF token error, cookie token: '${cookie_token}', state token: '${state_token}'`, true);
                    return;
                }
                this.$cookies.remove("_csrf");
                return true;

                // If state does not contain 3 "||" divided values, we don't have sid and we can't continue.
            }

            // State is nok - log it as well. But don't parse the sid.
            this.die(`Invalid state parameters. state: '${params?.state}''`);
            return false;
        },

        /**
         * Remove leftover cookies.
         *
         * @param askForResults - If yes, return cookie clearance status info
         * @returns Operation success
         */
        clearSidAndDataId() {
            this.$cookies.remove("sid", null, window.location.hostname);
            this.$cookies.remove("data_id", null, window.location.hostname);

            // Two stage clearing - just in case. This is basically generic clearance
            // pattern without host, which might be adequate for legacy browsers.
            if (this.$cookies.get("sid") || this.$cookies.get("data_id")) {
                this.$cookies.remove("sid");
                this.$cookies.remove("data_id");
            }
        },

        /**
         * Handle program parameters.
         *
         * @returns Operation status
         */
        async handleParameters() {
            // Loading modal.
            this.$refs.modals.show("process", false, {
                translate: true,
                title: "adhocModals.fetch.process.title",
                caption: "adhocModals.fetch.process.caption"
            });

            // Load parameters.
            let params = this.$helpers.paramsToObject();

            if (params.url) {
                let url;

                try {
                    url = new URL(decodeURIComponent(params.url));
                } catch (_) {
                    this.die(`invalid query parameter for url: '${params.url}'`, true);
                    return false;
                }

                if (!['http:', 'https:'].includes(url.protocol)) {
                    this.die(`invalid protocol of query parameter for url: '${params.url}'`, true);
                    return false;
                }
            }

            let hash = this.$helpers.getHash("access_token");

            /*******************
             *  NOT FROM SECV  *
             *******************/

            if (hash === false) {
                // Fetch dataId from cookies.
                const dataId = this.$cookies.get("data_id");

                // Fetch sid from cookies.
                const sid = this.$cookies.get("sid");

                if (!dataId || !sid) {
                    this.die(
                        `cookie dataId is '${dataId}', cookie sid is '${sid}'`,
                        true
                    );

                    return false;
                }

                // Clear the cookies - not needed anymore.
                this.clearSidAndDataId();

                // Attempt to retrieve SecV url. Error handling is in function itself.
                let secvUrl = await this.obtainSecvUrl();

                // Generate UUID and save it to cookies.
                const UUID = uuidv4();
                this.$cookies.set("_csrf", UUID);

                // Build final secV url.
                secvUrl += `${dataId}||${UUID}||${sid}`;

                // Perform redirect.
                window.location.href = secvUrl;
                return false;

                /********************
                 *  /NOT FROM SECV  *
                 ********************/
            }

            /*******************
             *    FROM SECV    *
             *******************/

            AuthToken.value = hash;
            const paramsValid = await this.validateSession(params);
            if (!paramsValid) return false;

            store.dispatch("setOne", {
                key: "language",
                value: this.$helpers.paramsToObject().lang
            });
            store.dispatch("setOne", {
                key: "id",
                value: params.state.split("||")[0]
            });
            store.dispatch("setOne", {
                key: "sid",
                value: params.state?.split("||")[2] || "no-sid"
            });

            // When everything is set, hash is not needed anymore.
            this.rmHash();

            return true;

            /***************
             * /FROM SECV  *
             ***************/
        },

        /**
         * Account selection with state management.
         *
         * @param accountData - Iban and name
         */
        accountSelectionRoutine({ accountIban, accountName }) {
            this.setSelectedAccount(accountIban);

            let diff =
                this.payment.selectedAccount.balanceDisposable -
                this.payment.suma;
            this.payment.isValid = diff >= 0;
            this.payment.error = this.payment.isValid
                ? ""
                : "overview.errors.diffError";
            this.payment.diff = Math.round(diff * 100) / 100;

            this.payment.signData = {
                userIban: accountIban,
                userAccountName: accountName,
                merchantAccountName: this.trader.title,
                amountToPay: this.payment.suma,
                recipientMessages: this.payment.recipientMessages,
                currency: this.payment.mena
            };
        },

    },

    /**
     * Main hook.
     */
    async mounted() {
        // Load initial data
        this.$api.decideEnvironment(window.location.hostname);

        // Merchant parameters.
        let mcParams;

        // Handle parameters. If it fails, just return from mounted. Errors are invoked from inside.
        let result = await this.handleParameters();
        if (result === false) {
            return result;
        }

        // Start general timeout.
        this.engageGeneralTimeout(900000);

        // Start token refreshing.
        this.$api.refreshToken(15);

        try {
            const id = store.getters.getOne("id");
            mcParams = (await this.$api.getMcParams(id)).data;
            // Log data id of client data request.
            this.genericLogger("data_request_ok", "");
            // API call failed
        } catch (e) {
            this.die("getMerchantData API call was unsuccessful", true);
        }

        // Modify and distribute loaded data.
        // We do not know if param is encoded or not. We decode it first - so we are sure it is decoded by default and encode it on it's way out.
        this.$helpers.forceDecode(mcParams.merchantData, [
            "param",
            "sign1",
            "url"
        ]);

        store.dispatch("setStoreParams", mcParams.merchantData);
        store.dispatch("setOne", { key: "isSepa", value: mcParams.isSepa });

        this.payment.recipientMessages = store.getters.getRecipientMessages;
        this.trader.accredited = !mcParams.isSepa;

        const storeParams = store.getters.getStoreParams;

        // Perform merchantCheck API call.
        this.$api
            .merchantCheck(mcParams.merchantData)
            .then(response => {
                // merchantCheck call succeeded.
                if (
                    !response.hasOwnProperty("error") &&
                    !response.hasOwnProperty("errors")
                ) {
                    let langnode = response.data.merchants.find(
                        item => item.lang === storeParams.language
                    );

                    if (!langnode) {
                        langnode = response.data.merchants.find(
                            item => item.lang === "sk"
                        );
                    }

                    this.trader.url = response.data.url;
                    this.trader.title = langnode.title || "";
                    this.trader.description = langnode.description || "";

                    // Call accounts API to retrieve accounts information.
                    this.$api
                        .accounts()
                        .then(response => {
                            if (
                                !response.hasOwnProperty("error") &&
                                !response.hasOwnProperty("errors")
                            ) {
                                // check if we have accounts
                                const weHaveAccounts = !!(
                                    response.data.accounts &&
                                    response.data.accounts.length
                                );

                                // if there is some fuckery
                                if (!weHaveAccounts) {
                                    // No auth method available.
                                    if (response.error === "noAuthTools") {
                                        this.die(
                                            "No auth tool available.",
                                            false,
                                            {
                                                title: "modals.noAuth.title",
                                                caption:
                                                    "modals.noAuth.caption",
                                                translate: "default"
                                            }
                                        );

                                        // Generic API failure.
                                    } else {
                                        this.die(
                                            "Accounts API call failed.",
                                            false
                                        );
                                    }
                                    return;
                                }

                                // all else
                                this.trader.puKbanky = storeParams.puKbanky;
                                this.trader.puPredcislo =
                                    storeParams.puPredcislo;
                                this.trader.puCislo = storeParams.puCislo;
                                this.trader.creditAccountIban =
                                    storeParams.creditAccountIban;
                                this.trader.ss = storeParams.ss;
                                this.trader.vs = storeParams.vs;
                                this.trader.payeeRef = storeParams.endToEndId;
                                this.payment.suma =
                                    Math.round(storeParams.suma * 100) / 100;
                                this.payment.mena = storeParams.mena;
                                this.payment.accounts = response.data.accounts;

                                if (response.data.accounts.length === 1) {
                                    let account = response.data.accounts[0];

                                    this.accountSelectionRoutine({
                                        accountIban: account.accountIban,
                                        accountName: account.accountName
                                    });
                                }

                                // Hide process modal when data is populated.
                                this.$nextTick(() => {
                                    this.$refs.modals.hide("process");
                                    this.handleSelect2();
                                });

                                // Failed accounts call.
                            } else {
                                // No auth method available.
                                if (response.error === "noAuthTools") {
                                    this.die("No auth tool available.", false, {
                                        title: "modals.noAuth.title",
                                        caption: "modals.noAuth.caption",
                                        translate: "default"
                                    });
                                    return;
                                    // Generic API failure.
                                }
                                this.die("Accounts API call failed.", false);
                            }
                        })
                        .catch(e => {
                            this.die(
                                e.message || e.response || "Vysypal sa accounts"
                            );
                        });

                    // Failed merchant check call.
                } else {
                    // API call failed.
                    throw new Error(response?.error || JSON.stringify(response?.errors ?? []));
                }
            })
            .catch(e => {
                this.clearSidAndDataId();
                this.genericLogger("merchant_check_failed", {
                        error_message: e.message ?? e
                    });
                this.$refs.modals.hide("process");
                this.$refs.modals.show('preventreturn');
            });
    }
};
</script>

<style lang="scss">
@use "assets/sass/main.scss";

.custom-a11y {
    &__wrapper {
        display: inline-block;
        position: relative;
    }

    &__label {
        height: 100%;
        position: absolute;
        width: 100%;
    }
}
</style>
